<template>
  <div class="wrap">
    <div class="banner">
      <img src="@/assets/image/workbanner.jpg" style="width: 100%" alt=""/>
    </div>
    <div class="pagew">
      <div class="timelist-box">
        <a @click="() => goList(2021-i)" v-for="(item, i) in list" :key="i" href="javascript:void(0);" class="timeline" :class="[`t-${i+1}`]">
          <div class="c">
            <p class="time">{{2021-i}}</p>
            <!-- <p class="t">{{item.t }}</p> -->
          </div>
        </a>
      </div>
    </div>
    <Footer :show="false"/>
  </div>
</template>

<script>
import { getWorkList } from '@/api/api.js';
export default {
  name: "index",
  data() {
    return {
      list: [
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },


        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },
        {
          time: '2020',
          t: '待定xxx'
        },

      ]
    };
  },
  created() {

  },
  methods: {
    goList(index) {
      this.$router.push({
        path: "Work/list",
        query: {
          key:index
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.timelist-box {
  margin-top: 20px;
  position: relative;
  width: 720px;
  margin: 30px auto;
  background: url('../../assets/image/work/line.png') no-repeat center top;
	height: 3330px;
}
.timeline {
  position: absolute;width: 429px;height: 134px;
  background-repeat: no-repeat;
  background-position: 0 0;
  .c {
    position: absolute;top: 36px;font-size: 18px;line-height: 30px;
    width: 280px;text-align: left;
  }
  .time {
    margin-top: 36px;font-weight: 700;
  }
  @for $i from 1 through 17 {
    &.t-#{$i} {
      top: ($i) * 200px - 200px;
      background-image: url('../../assets/image/work/#{$i}.png');
    }
  }

}
.timeline:nth-child(odd) {
  left: 50%;margin-left: -72px;
  .c {
    left: 156px;
  }
}
.timeline:nth-child(even) {
  left: 0;margin-left: 2px;
  .c {
    left: 0;text-align: right;
  }
  .time {}
}
</style>



// WEBPACK FOOTER //
// src/view/Work/index.vue